import { call, put } from 'redux-saga/effects';
import LogoutActions from '../redux/LogoutRedux';
import { api } from './api';


export function* logout(action: any): Generator<any, void, any> {
  // const { data } = action
  const response = yield call(api.logout);

  // success?
  if (response.ok) {
    // You might need to change the response here - do this with a 'transform',
    // located in ../Transforms/. Otherwise, just pass the data back from the api.
    yield put(LogoutActions.logoutSuccess());
  } else {
    yield put(LogoutActions.logoutFailure());
  }
}